import $ from "jquery";

(function () {
    const subscribe = {
        init: function () {
            $("#subscribe_submit").on("click", function (event) {
                event.preventDefault();

                let form = $("#subscribe_form");

                $.ajax({
                    url: form.attr("action"),
                    type: form.attr("method"),
                    dataType: "json",
                    data: form.serialize(),
                    success: function (data) {
                        alert(data.message);
                    }
                });
            });
        }
    }.init();
})();


// WEBPACK FOOTER //
// ./resources/assets/js/modules/subscribe.js